import { render, staticRenderFns } from "./SuppliersBookingSettingsBookings.vue?vue&type=template&id=5485a07d&"
import script from "./SuppliersBookingSettingsBookings.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettingsBookings.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersBookingSettingsBookings.vue?vue&type=style&index=0&id=5485a07d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports